<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><a class="page" id="pii"></a><img alt="" height="100" src="images/logo-chicago-guides.jpg" width="147"/></p>
<p class="serf"><i>Telling About Society</i></p>
<p class="serau">Howard S. Becker</p>
<p class="ser"><i>Tricks of the Trade</i></p>
<p class="serau">Howard S. Becker</p>
<p class="ser"><i>Writing for Social Scientists</i></p>
<p class="serau">Howard S. Becker</p>
<p class="ser"><i>The Craft of Research</i></p>
<p class="serau">Wayne C. Booth, Gregory G. Colomb, Joseph M. Williams, Joseph Bizup, and William T. FitzGerald</p>
<p class="ser"><i>The Chicago Guide to Grammar, Usage, and Punctuation</i></p>
<p class="serau">Bryan A. Garner</p>
<p class="ser"><i>Getting It Published</i></p>
<p class="serau">William Germano</p>
<p class="ser"><i>From Notes to Narrative</i></p>
<p class="serau">Kristen Ghodsee</p>
<p class="ser"><i>Thinking Like a Political Scientist</i></p>
<p class="serau">Christopher Howard</p>
<p class="ser"><i>Write No Matter What</i></p>
<p class="serau">Joli Jensen</p>
<p class="ser"><i>How to Write a BA Thesis</i></p>
<p class="serau">Charles Lipson</p>
<p class="ser"><i>The Chicago Guide to Writing about Multivariate Analysis</i></p>
<p class="serau">Jane E. Miller</p>
<p class="ser"><i>The Chicago Guide to Writing about Numbers</i></p>
<p class="serau">Jane E. Miller</p>
<p class="ser"><i>The Subversive Copy Editor</i></p>
<p class="serau">Carol Fisher Saller</p>
<p class="ser"><i>Going Public</i></p>
<p class="serau">Arlene Stein and Jessie Daniels</p>
<p class="ser"><i>Write Your Way In</i></p>
<p class="serau">Rachel Toor</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mccloskey-0003.vue?0bed6ee2